import { Box, Paragraph, Text } from '@zillow/constellation-10';
import AttachmentIcon from '../AttachmentIcon';
import { getAttachmentCardStyles } from '../styles';

type ExpiredAttachmentCardProps = {
  fileName: string;
  isImageFileType: boolean;
  isVideoFileType: boolean;
  variant?: 'sidebar' | 'message';
  isMessageOwner?: boolean;
};

export default function ExpiredAttachmentCard({
  fileName,
  isImageFileType,
  isVideoFileType,
  variant = 'sidebar',
  isMessageOwner = false,
}: ExpiredAttachmentCardProps) {
  const cardStyles = getAttachmentCardStyles(variant, isMessageOwner);

  return (
    <Box
      css={{
        ...cardStyles,
        backgroundColor: 'bg.softest',
      }}
    >
      <AttachmentIcon isImageFileType={isImageFileType} isVideoFileType={isVideoFileType} isDisabled />

      <Box css={{ paddingLeft: 'default', minWidth: 0 }}>
        <Paragraph
          textStyle="body-xs"
          css={{
            truncate: true,
            display: 'inline-block',
            verticalAlign: 'middle',
            maxWidth: '100%',
            color: 'text.subtle',
          }}
        >
          {fileName}
        </Paragraph>
        <Text textStyle="body-xs" css={{ color: 'text.subtle', verticalAlign: 'middle' }}>
          &nbsp;has expired and can’t be viewed.
        </Text>
      </Box>
    </Box>
  );
}
